<template>
    <div class="container">

        <b-modal id="viewAgentMemberModal" title="受講生情報" size="xl" ok-only ok-title="閉じる" modal-class="agent-netenglish-modal">
            <template #default>

                <b-card>
                    <b-row>
                        <b-col md="6"><strong>メールアドレス：</strong> {{ member.email }}</b-col>
                        <b-col md="6"><strong>ニックネーム：</strong> {{ member.nickname }}</b-col>
                        <b-col md="6"><strong>名：</strong> {{ member.firstname }}</b-col>
                        <b-col md="6"><strong>姓：</strong> {{ member.lastname }}</b-col>

                        <b-col md="6"><strong>性別：</strong> {{ member.gender }}</b-col>
                        <b-col md="6"><strong>通信アプリ：</strong> {{ member.communication_app }}</b-col>
                        <b-col md="6"><strong>通信アプリID：</strong> {{ member.communication_app_id }}</b-col>
                    </b-row>
                </b-card>

            </template>
        </b-modal>

    </div>
</template>


<script>
export default {

    props: {
        csrf_token: String,
        api_token: String,
        agent_info: Object,
        agent_user_id: Number,
    },
    data() {
        return {
            member: {},
        };
    },
    mounted() {

    },
    watch: {

    },
    methods: {

        openViewMemberModal(member) {
            console.log(member)
          
            this.$bvModal.show('viewAgentMemberModal');
            this.member = member;

            switch (member.communication_app.toLowerCase()) {
                case 'msteams':
                    this.member.communication_app_id = member.msteams_account;
                    break;
                case 'zoom':
                    this.member.communication_app_id = member.zoom_account;
                    break;
                case 'webrtc':
                    this.member.communication_app_id = 'マイページ レッスンルーム';
                    break;
                default:
                    this.member.communication_app_id = '';
            }
                        

            this.$forceUpdate();

        }


    }
};
</script>